import { isValidElement } from 'react';
import { Box } from '@chakra-ui/react';

import { SlotProp } from '../../@types';

type Props = {
  slot?: SlotProp,
  position?: 'top' | 'bottom',
};

export const Slot = ({ slot, position = 'top' }: Props) => {
  if (!slot) return null;
  // getting  slot element for position

  const {
    slot: renderSlot = null,
    position: renderPosition = 'top',
  } = Array.isArray(slot) ? slot.find(el => position === el.position) || {}
    : slot.slot ? slot : { slot };

  if (!renderSlot || !isValidElement(renderSlot)) return null;

  if (position !== renderPosition) return null;

  return (
    <Box
      paddingTop={ renderPosition === 'top' ? 6 : 4}
      className={`PaymentMethodSlot-${renderPosition}`}
    >
      {renderSlot}
    </Box>
  );
};
